import { render, staticRenderFns } from "./negative.vue?vue&type=template&id=5d0f74ed&scoped=true&"
import script from "./negative.vue?vue&type=script&lang=js&"
export * from "./negative.vue?vue&type=script&lang=js&"
import style0 from "./negative.vue?vue&type=style&index=0&id=5d0f74ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0f74ed",
  null
  
)

export default component.exports